import { styled } from "styled-components";

interface SendMoneyItemProps {
  icon: string;
  title: string;
  subtitle: string;
  altText?: string;
  index: number;
  lastIndex: number;
  onClick: () => void;
}

const SendMoneyItem: React.FC<SendMoneyItemProps> = ({
  icon,
  title,
  subtitle,
  altText,
  index,
  lastIndex,
  onClick,
}) => {
  return (
    <SendMoneyItemWrapper $isLast={index === lastIndex} onClick={onClick}>
      <IconWrapper src={icon} alt={altText} />
      <TextWrapper>
        <Title>{title}</Title>
        <SubTitle>{subtitle}</SubTitle>
      </TextWrapper>
    </SendMoneyItemWrapper>
  );
};

export default SendMoneyItem;

const SendMoneyItemWrapper = styled.div<{ $isLast?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border-bottom: ${({ $isLast }) => ($isLast ? "none" : "1px solid #e8eaed")};
`;
const Title = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #0e0e0e;
`;
const SubTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
  width: 357px;
  margin-bottom: 1rem;
  @media screen and (max-width: 767px) {
    width: 270px;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const IconWrapper = styled.img`
  height: 32px;
  width: 32px;
`;
